const EmptyLine = ({ dashed = false, ...rest }) => (
    <div style={{ borderBottom: `2px ${dashed ? 'dashed' : 'solid'} var(--grey-100)` }} {...rest} />
);

export default EmptyLine;
